<div class="date-picker">
  <ng-container *ngIf="!isLogin">
    <div class="row">
      <div class="col-12 col-md-3" style="margin: auto;">
        <div class="d-flex">
          <mat-form-field appearance="none" style="width: 100%;">
            <mat-select [(value)]="selectedMonth"  (selectionChange)="onMonthSelectionChange($event)" disableOptionCentering >
                <mat-option *ngFor="let month of months" [value]="month.val" [disabled]="month.isDisabled">{{month.mon}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="none" style="width: 85px;margin-left: 10px;">
            <mat-select [(value)]="selectedYear"  (selectionChange)="onYearSelectionChange($event)" disableOptionCentering >
                <mat-option *ngFor="let year of years" [value]="year.val" [disabled]="year.isDisabled">{{year.year}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div #hdpRef class="col-11 col-md-8 picker-day-outer">
       <button [disabled]="leftDisable" class="left-scroll-btn"><img  width="24" height="24" class="rh-left-arrow" src="/assets/images/left_arrow.svg" (click)="scrollLeft(hdpRef)" style="
        align-items: center;
       "></button>
        <div  class="custom-row-tabs"  (appHScroll)="showHideScrollArrows(hdpRef)" >
          <div *ngFor="let day of days" style="min-width: 14%;">
            <div  [ngClass]="(day.day == selectedDay) ? 'day-active' : 'day-inactive'"  >
              <p>{{day.label}}</p>
              <button (click)="dayClicked(day)" [ngClass]="day.isDisabled ? 'disabled-day-select-btn' : 'day-select-btn'"  [disabled]="day.isDisabled">{{day.day}}</button>
            </div>
          </div>
        </div>
        <button [disabled]="rightDisable" class="right-scroll-btn">
          <img width="24" height="24" class="rh-right-arrow" src="/assets/images/right_arrow.svg" (click)="scrollRight(hdpRef)" style="
          align-items: center;
          ">
        </button>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="isLogin">
    <div class="row">
      <div class="col-12 col-md-11" style="margin: auto;">
        <div class="d-flex">
          <mat-form-field appearance="none" style="width: 100%;  max-width: 250px;">
            <mat-select [(value)]="selectedMonth"  (selectionChange)="onMonthSelectionChange($event)" disableOptionCentering >
                <mat-option *ngFor="let month of months" [value]="month.val" [disabled]="month.isDisabled">{{month.mon}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="none" style="width: 85px;margin-left: 10px;">
            <mat-select [(value)]="selectedYear"  (selectionChange)="onYearSelectionChange($event)" disableOptionCentering >
                <mat-option *ngFor="let year of years" [value]="year.val" [disabled]="year.isDisabled">{{year.year}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div #hdpRef class="col-11 col-md-11 picker-day-outer">
       <button [disabled]="leftDisable" class="left-scroll-btn"><img  width="24" height="24" class="rh-left-arrow" src="/assets/images/left_arrow.svg" (click)="scrollLeft(hdpRef)" style="
        align-items: center;
       "></button>
        <div  class="custom-row-tabs"  (appHScroll)="showHideScrollArrows(hdpRef)" >
          <div *ngFor="let day of days" style="min-width: 14%;">
            <div  [ngClass]="(day.day == selectedDay) ? 'day-active' : 'day-inactive'"  >
              <p>{{day.label}}</p>
              <button (click)="dayClicked(day)" [ngClass]="day.isDisabled ? 'disabled-day-select-btn' : 'day-select-btn'"  [disabled]="day.isDisabled">{{day.day}}</button>
            </div>
          </div>
        </div>
        <button [disabled]="rightDisable" class="right-scroll-btn">
          <img width="24" height="24" class="rh-right-arrow" src="/assets/images/right_arrow.svg" (click)="scrollRight(hdpRef)" style="
          align-items: center;
          ">
        </button>
      </div>
    </div>
  </ng-container>

</div>
